let elements = {
  withoutReset: true,
  mainImage: {
    imagePath: 'games/page000_game10/img/bcg.jpg',
    pos: {
      x: 183,
      y: 0,
    },
    width: 1554,
    height: 1080,
  },
  withoutCheck: true,
  //imageHighlight: false,
  //imageHighlightColor: 'red',
  mbAudioItemData: [
    {
      src: 'games/page000_game10/audio/68_jacket.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game10/img/audioOn.png', iconOff: 'games/page000_game10/img/audioOff.png' },
        fill: 'none',
      },
      width: '50px',
      height: '50px',
      pos: {
        y: 295,
        x: 305,
      },
      unit: 'px',
    },
    {
      src: 'games/page000_game10/audio/70_jeans.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game10/img/audioOn.png', iconOff: 'games/page000_game10/img/audioOff.png' },
        fill: 'none',
      },
      width: '50px',
      height: '50px',
      pos: {
        y: 665,
        x: 305,
      },
      unit: 'px',
    },
    {
      src: 'games/page000_game10/audio/69_shoes.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game10/img/audioOn.png', iconOff: 'games/page000_game10/img/audioOff.png' },
        fill: 'none',
      },
      width: '50px',
      height: '50px',
      pos: {
        y: 945,
        x: 305,
      },
      unit: 'px',
    },
  ],
};

export default elements;
